import { Group, Text } from "@mantine/core";
import { DataViewPage, EntityClientAction } from "@mcurros2/microm";
import { IconAlertCircle } from "@tabler/icons-react";
import { DatosServiciosAutorizacion } from "../DatosServicios/DatosServiciosAutorizacion/DatosServiciosAutorizacion";
import { DatosServiciosAutorizacionCard } from "../DatosServicios/DatosServiciosAutorizacion/DatosServiciosAutorizacionCard";
import { AppSupervisor } from "./AppSupervisor";

export const ACTVerReportesPersonal: EntityClientAction = {
    name: 'ACTVerReportesPersonal',
    label: 'Ver Reportes Personal',
    title: <Text fw={700}>Ver Reportes</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: [''],
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const parent = entity as AppSupervisor;
        const datos = new DatosServiciosAutorizacion(entity.API.client);
        datos.parentKeys = parent.parentKeys;
        datos.def.columns.c_personal_id.value = selectedKeys![0].c_personal_id as unknown as string || '';

        await modal.open({
            modalProps: {
                title: <Group><IconAlertCircle size="1.5rem" stroke="1.5" /> <Text fw="700">Reportes</Text></Group>,
                size: "xl"
            },
            focusOnClosed: element,
            content: <DataViewPage
                key="reportes-personal"
                client={entity.API.client}
                entityConstructor={() => datos}
                viewName="dasa_brwAutorizacionPorPersonal"
                refreshOnInit
                enableAdd={false}
                enableDelete={false}
                enableEdit={false}
                enableView={true}
                selectionMode="single"
                Card={DatosServiciosAutorizacionCard} />          
        });

        return false;
    }
}